// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"389":"8104e41751679e75","5751":"075f31bb28ce2ff5"}[chunkId] + ".js";
};